import axios from 'axios';

import { checkShouldUseMocks } from './envUtils';

export const axiosWithFetch = axios.create({
    adapter: process.env.NODE_ENV !== 'test' ? 'fetch' : undefined,
    baseURL: checkShouldUseMocks() ? process.env.HYBRIS_PUBLIC_URL : undefined,
});
